//core
import React from "react";
import { useTranslation } from "react-i18next";
import { Box, Chip, Typography } from "@mui/material";

//styles
import { useStyles } from "../../styles";

//colors
import { green } from "@mui/material/colors";

//utils
import { getStepsByProduct } from "../../../PaymentPlanForm/utils";

//components
import CpaSteps from "./CpaSteps";
import { ObjType } from "../../../../utils";
import { ChipRed } from "../../../../styles";
interface ICpaProps {
  data: ObjType;
}

const Cpa: React.FC<ICpaProps> = ({
  data,
}): JSX.Element => {
  const { t } = useTranslation();
  const styles = useStyles();

  return (
    <>
      {!!data.condition_items_attributes.length && <>
        <Box className={styles.field}>
          <Typography variant="body2">
            {t("admin.deals.summary.qualified_when")}:
          </Typography>

          {data.condition_items_attributes.map((attributes: any, i: number) => {
            const desired_value = attributes.desired_value !== null ? attributes.desired_value : '';
            const label =
              attributes.obtained_result === 'external_qualified'
                ? t(`common.components.obtained_result.lead_qualified`)
                : t(`common.components.obtained_result.${attributes.obtained_result}`);

            return (<ChipRed
              key={`deal-${i}`}
              size="small"
              label={`${label} ${t("admin.deals.summary.is")} ${t(`admin.deals.summary.comparison.${attributes.condition_for_comparison}`)} ${desired_value}`}
            />)
          })}
        </Box>

        <CpaSteps data={getStepsByProduct([...data.condition_steps_attributes], null)} />
      </>}
    </>
  );
};

export default Cpa;
